var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 63,
    viewBox: "0 0 109 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.25 58.0312C108.25 55.806 106.444 54 104.219 54H4.78125C2.556 54 0.75 55.806 0.75 58.0312C0.75 60.2565 2.556 62.0625 4.78125 62.0625H104.219C106.444 62.0625 108.25 60.2565 108.25 58.0312ZM108.25 31.1562C108.25 28.931 106.444 27.125 104.219 27.125H4.78125C2.556 27.125 0.75 28.931 0.75 31.1562C0.75 33.3815 2.556 35.1875 4.78125 35.1875H104.219C106.444 35.1875 108.25 33.3815 108.25 31.1562ZM108.25 4.28125C108.25 2.056 106.444 0.25 104.219 0.25H4.78125C2.556 0.25 0.75 2.056 0.75 4.28125C0.75 6.5065 2.556 8.3125 4.78125 8.3125H104.219C106.444 8.3125 108.25 6.5065 108.25 4.28125Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHamburger);
export default __webpack_public_path__ + "static/media/ic_hamburger.93b5c466d3765242b39f4496e6071f97.svg";
export { ForwardRef as ReactComponent };